"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationsLocalStorageService = void 0;

var _streams = require("../streams");

var _actions = require("./actions");

var saveNotificationsHistoryState = function saveNotificationsHistoryState(history) {
  try {
    localStorage.setItem('notificationsHistory', JSON.stringify(history));
  } catch (err) {
    console.log('[notificationsHistory]: Could not save data to local storage.', err);
  }
};

var loadNotificationsHistoryState = function loadNotificationsHistoryState() {
  try {
    var serializedState = localStorage.getItem('notificationsHistory');

    if (serializedState === null) {
      return [];
    }

    return JSON.parse(serializedState);
  } catch (err) {
    return [];
  }
};

var notificationsLocalStorageService = function notificationsLocalStorageService(store) {
  // subscribe to the state and save every change inside notifications.history
  new _streams.Observable(function (observer) {
    store.subscribe(function () {
      observer.next(store.getState());
    });
  }).map(function (state) {
    return state.get ? state.get('notifications').history : state.notifications.history;
  }).filterUnchanged().filter(function (_, index) {
    return index > 0;
  }) // skip the first change (at first the local storage is overriding the history object)
  .subscribe(function (history) {
    saveNotificationsHistoryState(history);
  }); // Load the history array from local storage into state

  store.dispatch((0, _actions.loadHistoryNotifications)(loadNotificationsHistoryState()));
};

exports.notificationsLocalStorageService = notificationsLocalStorageService;
//# sourceMappingURL=notifications-localstorage-service.js.map